import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import {AdminService} from "../admin.service";
import {ToastrService} from "ngx-toastr";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-add-manager',
  templateUrl: './add-manager.component.html',
  styleUrls: ['./add-manager.component.scss']
})
export class AddManagerComponent implements OnInit {

  manObj:any = {};
  dataLoading:boolean;
  managers;
  projects;
  selectedManager: any;
  edit:boolean;
  OldUser:boolean;

  //autosuggest
  currentFocus:number = 0;
  suggestedValues: any = [];
  showDropDown: boolean = false;
  timer: any = 0;
  delay: number = 500;
  preLoader: boolean = false;

  modalRef: BsModalRef;
  @ViewChild('f' , {static: true}) form;

  constructor(private _adminService: AdminService,
              private toastr: ToastrService,
              private modalService: BsModalService) { }

  ngOnInit() {
    this.getProject();
    this.getManager();
  }
  getProject() {
    this._adminService.getProject().subscribe(res=>{
      this.projects = res;
    }, err=>{
    })
  }

  getManager() {
    this.dataLoading = true;
    this._adminService.getManager().subscribe(res=>{
      this.managers = res;
      this.dataLoading = false;
    }, err=>{
      this.dataLoading = false;
    })
  }
  addManager(){
    if (this.edit) {
      this._adminService.saveEditManager(this.manObj).subscribe(res=>{
        this.form.resetForm();
        this.edit = false;
        this.OldUser = false;
        this.getManager();
        this.toastr.success('Manager creation', 'User updated successfully!');
      }, err=>{
        this.toastr.error('Manager creation', 'Error updating user!');
      })

    } else {
      this._adminService.addManager(this.manObj).subscribe(res=>{
        this.form.resetForm();
        this.edit = false;
        this.OldUser = false;
        this.getManager();
        this.toastr.success('Manager creation', 'User added successfully!');
      }, err=>{
        this.toastr.error('Manager creation', 'Error adding user!');
      })
    }
  }

  editManager(arr) {
    this.form.resetForm();

    let projectIds = [];

    let projLis = arr.project;

    for (var i = 0; i < projLis.length; i++) {
      let obj = projLis[i];

      if (obj) {
        let name = obj['pId'];
        let role = obj['role'];

        for (var j = 0; j < role.length; j++) {

          if (role[j] === 'Manager') {
            projectIds.push(name);
          }
        }

      }
    }

    this.manObj.username = arr.name;
    /*        this.manObj.password = arr.password;
     this.manObj.repassword = arr.password;*/
    this.manObj.email = arr.userInfo.email;
    this.manObj.activeproj = projectIds;

    this.edit = true;
    this.gotoTop();
  }
  deleteManager(){
    this._adminService.deleteManager(this.selectedManager.name).subscribe(res=>{
      this.toastr.success('Manager creation', 'User deleted successfully!');
      this.getManager();
      this.OldUser = false;
    }, err=>{
      this.toastr.error('', 'Error in deleting project!');
    })
  }
  openModal(template: TemplateRef<any>, manager) {
    this.modalRef = this.modalService.show(template);
    this.selectedManager = manager;
  }

  confirm(): void {
    this.deleteManager();
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  hide() {
    this.showDropDown = false;
    this.currentFocus = 0;
  }
  //
  show() {
    this.showDropDown = true;
  }
  onSelectedValue(name){
    this.manObj.username = name;
    this.hide();
    this.OldUser = true;
  }

}
